// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"zwa-z","narrowOptionButtons":"Awa-z","noOptions":"Bwa-z"};